const WhatsAppFloat = () => {
  const handleClick = () => {
    window.open(
      'https://wa.me/5200000000000?text=Hola%2C%20me%20interesa%20cotizar%20pantallas%20para%20mi%20evento',
      '_blank'
    );
  };

  return (
    <button
      onClick={handleClick}
      aria-label="Contactar por WhatsApp"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 flex items-center justify-center rounded-full bg-gradient-to-br from-cyan-500 to-sky-600 text-white cursor-pointer whitespace-nowrap"
      style={{
        animation: 'waPulse 2.5s ease-in-out infinite',
      }}
    >
      <i className="ri-whatsapp-line text-2xl" />
      <style>{`
        @keyframes waPulse {
          0%, 100% { box-shadow: 0 0 0 0 rgba(6, 182, 212, 0.5); }
          50% { box-shadow: 0 0 0 14px rgba(6, 182, 212, 0); }
        }
      `}</style>
    </button>
  );
};

export default WhatsAppFloat;
